export class LocationTag {
    id!: string;
    name!: string;
    description?: string;
    associatedLocations?: number;
  }